class StreamHandler {
  constructor(onChunk, onComplete, onError, onMeta) {
    this.onChunk = onChunk;
    this.onComplete = onComplete;
    this.onError = onError;
    this.onMeta = onMeta;
    this.abortController = new AbortController();
    this.fullContent = '';
  }

  async handleStream(response) {
    try {
      const reader = response.body.getReader();
      const decoder = new TextDecoder();

      while (true) {
        const { done, value } = await reader.read();

        if (done) {
          this.onComplete();
          break;
        }

        const chunk = decoder.decode(value, { stream: true });
        const lines = chunk.split('\n');

        for (const line of lines) {
          if (line.startsWith('data: ')) {
            const data = line.slice(6);

            if (data === '[DONE]') {
              continue;
            }

            try {
              const parsed = JSON.parse(data);

              if (parsed.conversation_id && this.onMeta) {
                this.onMeta({ conversationId: parsed.conversation_id });
              }

              if (parsed.content) {
                this.fullContent += parsed.content;
                this.onChunk(this.fullContent);
              }

              if (parsed.error) {
                throw new Error(parsed.error);
              }
            } catch (parseError) {
              if (parseError.message && !parseError.message.includes('JSON')) {
                throw parseError;
              }
            }
          }
        }
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        return;
      }
      this.onError(error);
    }
  }

  cancel() {
    this.abortController.abort();
  }
}

export default StreamHandler;
